<template>
  <span ref="mathJaxEl" class="1123 mathJaxEl" v-html="formula"></span>
</template>

<script>
export default {
  props: {
    formula: {
      type: String,
    },
    safe: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    formula() {
      this.renderMathJax();
    },
  },
  mounted() {
    this.renderMathJax();
    // 手动触发 MathJax 渲染
  },
  methods: {
    async renderMathJax() {
      // this.renderContent();
      await this.$nextTick();
      if (window.MathJax) {
        await window.MathJax.typesetPromise([this.$refs.mathJaxEl])
        .then(() => {
          this.$emit("onRenderComplete");
        }).catch(() => {
          this.$emit("onRenderComplete");
        });
      }
    },
  },
};
</script>

<style lang="scss">
.mathJaxEl {
  width: 100%;
  height: fit-content;
  display: inline-block;
  * {
    font-family: GenSenRoundedTW,Helvetica,Arial !important;
  }
  .mjx-c23DE {
    font-family: MJXZERO, MJXTEX !important;

    * {
      font-family: MJXZERO, MJXTEX-S1, MJXTEX-S4, MJXTEX, MJXTEX-A !important;
    }
  }
}
</style>